/** @jsx jsx */
import { jsx } from '@emotion/core'
import { BottomLoadingWrap } from '@styles/base.style'

function BottomLoading() {
  return (
    <BottomLoadingWrap className="bottom-loading-wrap">
      <div className="default">
        <span className="default--bar"/>
      </div>
    </BottomLoadingWrap>
  )
}

export default BottomLoading
